import { render } from "./hamkari.vue?vue&type=template&id=aa90e356"
import script from "./hamkari.vue?vue&type=script&lang=js"
export * from "./hamkari.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/omidnoorani-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__